import React from 'react';
import { ButtonLink } from '../components/ButtonLink';
export function NotFound() {
  return <section className="bg-midnight-950 text-champagne-50" data-id="element-476" data-mp="w3rfrsvikml8">
      <div className="mx-auto flex min-h-[60vh] max-w-site flex-col justify-center px-6 py-24 lg:px-10" data-id="element-477" data-mp="w6dovwy1za5k">
        <h1 className="font-serif text-5xl md:text-6xl" data-id="element-478" data-mp="1087jpolkhjxt">This page isn’t available.</h1>
        <p className="mt-5 max-w-xl text-lg text-champagne-100/70" data-id="element-479" data-mp="152v0t2e8rc2d">The page you’re looking for may have moved. Let’s get you back on track.</p>
        <div className="mt-10 flex flex-wrap gap-4" data-id="element-480" data-mp="1f2ly1bu6s565">
          <ButtonLink to="/" withArrow data-id="element-481" data-mp="1f110ddcks642">Return home</ButtonLink>
          <ButtonLink to="/contact" variant="outlineDark" data-id="element-482" data-mp="1juwvm81gfevj">Contact Us</ButtonLink>
        </div>
      </div>
    </section>;
}